module.exports = __webpack_public_path__ + "img/inco1.46ab4107.png";